import {
  ADMIN,
  COMMON,
  ifyouApi,
  ifyouApiGame,
  ifyouApiLive,
} from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';
import { IDropListProps, ISearchData } from 'utils/types/common';

interface IProps {
  id: string | number;
  userId: string | number;
  adminId: string | number;
  projectId: string | number;
  resetId?: number;
  property?: string;
  searchDate?: string;
  missionType?: string;
}

interface IRecord {
  mail_no: string | number;
  reservation_no: string | number;
}

export const userApi = {
  // 유저 리스트
  read: (searchData: ISearchData) =>
    ifyouApi
      .post(`${ADMIN}/op-user-list`, {
        search_type: searchData.searchType,
        search_word: searchData.searchWord,
        page: '-1',
        page_size: '20',
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 유저 상세 정보
  detail: (id: string | number) =>
    ifyouApi
      .get(`${ADMIN}/${id}/op-user-detail`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 유저 재화 탭
  currencyUsedList: (
    id: string,
    property: string | undefined,
    searchDate: ISearchData,
  ) =>
    ifyouApi
      .post(`${ADMIN}/${id}/op-user-currency`, {
        property: property,
        from_date: searchDate.search_start_date,
        to_date: searchDate.search_end_date,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 쿠폰 기록
  couponUsedList: (id: string, searchDate: ISearchData) =>
    ifyouApi
      .post(`${ADMIN}/${id}/op-user-coupon`, {
        search_start_date: searchDate.search_start_date,
        search_end_date: searchDate.search_end_date,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 우편함
  mailReceivedList: (id: string, searchData: ISearchData) =>
    ifyouApi
      .post(`${ADMIN}/${id}/op-user-mail`, {
        search_date_type: searchData.search_date_type,
        search_start_date: searchData.search_start_date,
        search_end_date: searchData.search_end_date,
        search_state: searchData.search_state,
        search_currency: searchData.search_currency?.toString(),
        search_mail_type: searchData.search_mail_type,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 우편 취소
  mailDelete: (
    id: string,
    adminId: string,
    record: IRecord,
    searchData: ISearchData,
  ) =>
    ifyouApi
      .post(`${ADMIN}/${id}/op-user-mail-delete`, {
        mail_no: record.mail_no,
        reservation_no: record.reservation_no,
        admin_id: adminId,
        search_date_type: searchData.search_date_type,
        search_start_date: searchData.search_start_date,
        search_end_date: searchData.search_end_date,
        search_state: searchData.search_state,
        search_currency: searchData.search_currency?.toString(),
        search_mail_type: searchData.search_mail_type,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 수집 리스트
  collectionList: (userId: string) =>
    ifyouApi
      .get(`${ADMIN}/${userId}/op-user-collection`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 수집 상세
  collectionDetail: (userId: number | string, projectId: number) =>
    ifyouApi
      .post(`${ADMIN}/${userId}/op-user-collection-detail`, {
        project_id: projectId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  // 미션 리스트
  missionList: (userId: string) =>
    ifyouApi
      .get(`${ADMIN}/${userId}/op-user-mission`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 미션 디테일
  missionDetail: (userId: string, projectId: number) =>
    ifyouApi
      .post(`${ADMIN}/${userId}/op-user-mission-detail`, {
        project_id: projectId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 미션 초기화
  missionReset: (userId: string, missionType: string, resetId: string) =>
    ifyouApi
      .post(`${ADMIN}/${userId}/op-user-mission-delete`, {
        mission_type: missionType,
        project_id: missionType === 'all' ? resetId : '',
        mission_id: missionType === 'some' ? resetId : '',
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};
export const userApi_Live = {
  // 유저 리스트
  read: (searchData: ISearchData) =>
    ifyouApiLive
      .post(`${ADMIN}/op-user-list`, {
        search_type: searchData.searchType,
        search_word: searchData.searchWord,
        page: '-1',
        page_size: '20',
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 유저 상세 정보
  detail: (id: string | number) =>
    ifyouApiLive
      .get(`${ADMIN}/${id}/op-user-detail`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 유저 재화 탭
  currencyUsedList: (id: string, property: string, searchDate: ISearchData) =>
    ifyouApiLive
      .post(`${ADMIN}/${id}/op-user-currency`, {
        property: property,
        from_date: searchDate.search_start_date,
        to_date: searchDate.search_end_date,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 쿠폰 기록
  couponUsedList: (id: string, searchDate: ISearchData) =>
    ifyouApiLive
      .post(`${ADMIN}/${id}/op-user-coupon`, {
        search_start_date: searchDate.search_start_date,
        search_end_date: searchDate.search_end_date,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 우편함
  mailReceivedList: (id: string, searchData: ISearchData) =>
    ifyouApiLive
      .post(`${ADMIN}/${id}/op-user-mail`, {
        search_date_type: searchData.search_date_type,
        search_start_date: searchData.search_start_date,
        search_end_date: searchData.search_end_date,
        search_state: searchData.search_state,
        search_currency: searchData.search_currency,
        search_mail_type: searchData.search_mail_type,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 우편 취소
  mailDelete: (
    id: string,
    adminId: string,
    record: IRecord,
    searchData: ISearchData,
  ) =>
    ifyouApiLive
      .post(`${ADMIN}/${id}/op-user-mail-delete`, {
        mail_no: record.mail_no,
        reservation_no: record.reservation_no,
        admin_id: adminId,
        search_date_type: searchData.search_date_type,
        search_start_date: searchData.search_start_date,
        search_end_date: searchData.search_end_date,
        search_state: searchData.search_state,
        search_currency: searchData.search_currency?.toString(),
        search_mail_type: searchData.search_mail_type,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 수집 리스트
  collectionList: (userId: string) =>
    ifyouApiLive
      .get(`${ADMIN}/${userId}/op-user-collection`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 수집 상세
  collectionDetail: (userId: number | string, projectId: number) =>
    ifyouApiLive
      .post(`${ADMIN}/${userId}/op-user-collection-detail`, {
        project_id: projectId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 미션 리스트
  missionList: (userId: string) =>
    ifyouApiLive
      .get(`${ADMIN}/${userId}/op-user-mission`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 미션 디테일
  missionDetail: (userId: string, projectId: number) =>
    ifyouApiLive
      .post(`${ADMIN}/${userId}/op-user-mission-detail`, {
        project_id: projectId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  // 미션 초기화
  missionReset: (userId: string, missionType: string, resetId: string) =>
    ifyouApiLive
      .post(`${ADMIN}/${userId}/op-user-mission-delete`, {
        mission_type: missionType,
        project_id: missionType === 'all' ? resetId : '',
        mission_id: missionType === 'some' ? resetId : '',
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};

// * 유저 관리 - 데이터 변경: 슈퍼 유저 관리
export const superUserApi = (userkey) =>
  ifyouApiGame
    .post(`/client`, { func: 'changeAdminAccountStatus', userkey: userkey })
    .then((res) => res.data)
    .catch((error) => {
      if (error.response) {
        ErrorMessage(error.response.status, error.response.data);
      }
    });
// * 유저 관리 - 데이터 변경: 히든 요소 해금하기
export const unlockHiddenApi = (userkey, projectId) =>
  ifyouApiGame
    .post(`/client`, {
      func: 'unlockProjectHiddenElements',
      userkey: userkey,
      project_id: projectId,
    })
    .then((res) => res.data)
    .catch((error) => {
      if (error.response) {
        ErrorMessage(error.response.status, error.response.data);
      }
    });
